var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body min-h-100 overflow-x-hidden"},[_c('HeaderComponent'),_vm._t("default"),_c('FooterComponent')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }